<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, nextTick, reactive } from "vue";
import { Globals } from "@/Globals";
import { showSnackbar } from "@/UIHelper";
import { getKennungValue, getColumnByKennung, getValue } from "@/DataHelper";
import { formatDate } from "@/editor/CalenderHelper";
// import { goBack } from "@/NavigationHelper";

import {
  createEditorValidator,
  provideEditorValidator,
} from "@/components/EditorValidator";
const validator = createEditorValidator();
provideEditorValidator(validator);

import { globalsBezeichnung, globalsBegriffMemo } from "@/local";
const props = defineProps<{
  inputData?: any;
  query?: string;
  aic?: number;
  mainAic?: number;
  mainStt?: number;
  columnsOvr?: DataColumn[];
  preloadedData?: any;
  zeitbereich?: APIZeitbereich;
  showBaseButton?: string;
  showBackButton?: boolean;
  showSaveButton?: boolean;
  showDeleteButton?: boolean;
  showTitle?: boolean;
  maxWidth?: number;
  maxHeight?: number;
  url?: string;
  backOnSave?: boolean;
  lastValues?: any;
  bewegungsdaten?: boolean;
  readonly?: boolean;
  activateSave?: boolean;
  newData?: boolean;
  openFromDialog?: boolean;
  siteData?: any;
  fieldCssClass?: string | null;
  numberOfColumns?: number;
  mehrfach?: boolean;
  showTimeField?: boolean;
}>();
let thisIsAnEditPage: boolean = true;
function isValueChangeTrackerEnabled() {
  if (!header.aicBew) {
    return true;
  }
  return false;
}
let activateSaveMutable = ref<boolean>(props.activateSave);
let readOnlyMutable = ref<boolean>(props.readonly ?? false);
let setKey = ref<number>(0);
let setKeyComponent = ref<number>(0);
let header: any = { bezeichnung: "lade..." };
let columns = ref<DataColumn[]>([]);

let data: QueryData = {} as QueryData;
let validations: EditControlValidation[] = [];
let aicBew = ref<number>(0);
let aicStamm = ref<number>(0);
let stammtyp = ref<number>(0);

let doShowSaveButton = ref<boolean>(true);
let doShowBaseButton = ref<boolean>(true);

let doShowTitle = ref<boolean>(true);
let kennungStichtagCol: string = "STAMMSTICHTAG";
let stichtag = ref<Date | null>(null);
let showTimeFieldLocal = ref<boolean>(false);
// anzahl der Spalten als ZAHL übergeben... damit klappt es wieder...
let numberOfColumns = 6;

import {
  mountedBase,
  BaseSetup,
  onDelete,
  onSave,
  reloadData,
} from "@/DataLoaderStatic";
import { SetEditValueParameters } from "@/editor/EditComponentStatic";
import Constants from "@/Constants";
const emit = defineEmits(["back", "save", "delete", "ready"]);
const pageParams: DataPageParameter = {
  zeitbereich: props.zeitbereich ?? AUApi.Current.zeitbereich,
  insertMode: false,
  query: props.query,
  aic: props.aic,
  bewegungsdaten: props.bewegungsdaten,
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));

uiData.columns = columns.value;
uiData.data = data;

onMounted(async () => {
  showTimeFieldLocal.value = props.showTimeField;
  if (Constants.isMobile) {
    numberOfColumns = 12;
  } else {
    numberOfColumns = props.numberOfColumns ?? 6;
  }

  if (props.aic) {
    pageParams.aic = props.aic;
    pageParams.queryAIC = props.aic;
    pageParams.mainAic = props.mainAic;
  }
  if (props.showBaseButton === "false" || props.showBaseButton === "0") {
    doShowBaseButton.value = false;
  }
  if (!props.showSaveButton) {
    doShowSaveButton.value = false;
  }
  if (!props.showTitle) {
    doShowTitle.value = false;
  }
  if (props.columnsOvr) {
    columns.value = props.columnsOvr;
  }
  await mountedBase(uiData, pageParams, false);
  if (!uiData.showLoading && uiData.data) {
    if (!uiData.header.edit) {
      doShowSaveButton.value = false;
    }
    if (uiData.header?.aicStt) {
      stammtyp.value = uiData.header.aicStt;
    }
  }
  for (let i = 0; i < uiData.columns.length; i++) {
    uiData.columns[i].filter = "";
  }
  if (uiData.header.spAnzahl === 1) {
    numberOfColumns = 12;
  }

  columns.value = uiData.columns.filter((c: any) => c.meta.invisible !== true);

  if (props.newData) {
    for (let i = 0; i < columns.value.length; i++) {
      if (
        columns.value[i].datatype === "Austritt" ||
        columns.value[i].datatype === "Stichtag" ||
        (columns.value[i].datatype === "BewDatum2" &&
          columns.value[i].kennung === "ENDEBEW") // Ende bei Bewegungen bei NEU autom. disablen
      ) {
        columns.value[i].meta.readOnly = true;
      }
    }
  }

  let data2Backup = uiData.data;
  if (data2Backup.length > 0) {
    data2Backup = data2Backup[0] as QueryData;
  }
  pageParams.backupData = JSON.parse(JSON.stringify(data2Backup));

  const defColumsNoChange = uiData.columns.filter(
    (c: any) => c.kennung === "NOCHANGE",
  );
  const defColumsAllowDelete: any = uiData.columns.filter(
    (c: any) => c.meta.kz === "allowDelete",
  );
  // ist der Stammsatz zB von einem anderen Mandaten - dann darf er auch nciht gelöscht werden!
  if (defColumsNoChange && defColumsNoChange?.length > 0) {
    const noChange = getValue(uiData.data[0], defColumsNoChange[0]);
    if (noChange) {
      readOnlyMutable.value = true;
    }
  }

  if (defColumsAllowDelete && defColumsAllowDelete?.length > 0) {
    const allowDelete = getValue(uiData.data[0], defColumsAllowDelete[0]);
    if (!allowDelete) {
      readOnlyMutable.value = true;
    }
  }
  // kz - save - kann steuern ob Änderungen noch erlaubt sind!
  const defsave: any = uiData.columns.filter((c: any) => c.meta.kz === "save");
  if (defsave && defsave?.length > 0) {
    const allowSave = getValue(uiData.data[0], defsave[0]);
    if (!allowSave) {
      readOnlyMutable.value = true;
    }
  }
  uiData.showLoading = false;
  uiData.initialized = true;
  emit("ready", uiData);
});

function getColumnClass() {
  // Dynamically return class for columns
  return numberOfColumns;
}
function timeChanged(value?: string) {
  if (value) {
    stichtag.value = new Date(value);
  }
  if (stichtag.value) {
    AUApi.Current.stichtag = stichtag.value;
  }
}
function fixTitle(text?: string): string {
  if (!text) return "";
  let t = text;
  if (t.slice(0, 3).toLowerCase() === "web") {
    t = t.slice(4);
    t = t.replace(/_/g, " ");
  }
  return t;
}
function getEditValue(field: DataColumn) {
  const x = data[0];
  if (x) {
    return x[field.name];
  }
  return x;
}
function getLastValue(field: any) {
  const x = props.lastValues;
  if (x) {
    return x[field.name];
  }
  return x;
}
function getPassValue(field: any) {
  const x = data[0];
  const passName = field.meta.ohrSpalte;
  if (x && passName) {
    const passValue = x[passName];
    if (passValue) {
      return passValue.sttBez + ": " + passValue.bezeichnung;
    } else if (passName && field.meta.eig2) {
      return field.meta.eig2.bezeichnung;
    }
  }
}
function getStichtagValue(field: any) {
  const x = data[0];
  const stichtagName = field.meta.stichtagSpalte;

  if (x && stichtagName) {
    const dateString = x[stichtagName];
    if (dateString) {
      const date = new Date(dateString);
      let stichtagDatum = formatDate(new Date(date), "dd.MM.yyyy");
      if (stichtagDatum === "01.01.1970") {
        stichtagDatum = "Eintritt";
      }
      return stichtagDatum;
    }
  }
}
// Daten vorbereiten zum Speichern
function setValue(evt: SetEditValueParameters) {
  if (data.length === 0) {
    data.push({});
  }
  data[0][evt.field.name] = evt.value;
}
function getEditComponent(field: any) {
  const typeName =
    // richtig formatieren ==> der Compontenname wird hier zusammengesetzt!
    "edit" + field.type.substring(0, 1).toUpperCase() + field.type.substring(1);
  console.log(typeName);
  return typeName;
}

async function onValidate() {
  return await validator.validateAsync();
}

// function getDialogData() {
//   const x: any = [];
//   return data;
// }
async function save() {
  const isvalid = await onValidate();
  if (!isvalid.valid) {
    showSnackbar({
      text:
        "Validierung fehlgeschlagen - Bitte prüfen! (" +
        isvalid.invalidFields.join(", ") +
        ")",
      duration: 4000,
      color: "error",
    });
    return;
  }
  // data ist leer.. daher bekomm ich einen Fehler.
  if (!stichtag.value) {
    stichtag.value = getKennungValue(
      data[0],
      kennungStichtagCol,
      columns.value,
    );
  }
  const res = await onSave(
    uiData,
    pageParams,
    0,
    "",
    undefined,
    pageParams.aic,
    true,
    [],
    uiData.saveNodeRequest,
    stichtag.value,
  );
  if (res) {
    const updateData = res.data;

    if (stichtag.value) {
      uiData.initialized = false;
      uiData.showLoading = true;
      for (const key of Object.keys(updateData)) {
        if (key !== "aic_Stamm") {
          data[key as any] = updateData[key];
          const column = columns.value.find((col: any) => col.name === key);
          if (column && column.meta.stichtag) {
            // der stichtag kommt als eigenes Data -daher muss ich den gesondert ersetzen!
            const stichtagSpalte = column.meta.stichtagSpalte;
            if (stichtagSpalte) {
              const newStichtag = updateData[stichtagSpalte];
              data[0][stichtagSpalte] = newStichtag;
              // Stichtag umgesetzt  - wie sag ich es der Komponente?
            }
          }
        }
      }
      AUApi.Current.stichtag = null;
      showTimeFieldLocal.value = false;
      stichtag.value = null;
      nextTick(
        () => (
          ((uiData.initialized = true), (uiData.showLoading = false)),
          (showTimeFieldLocal.value = true)
        ),
      );
      // $forceUpdate();
    }
    // Columns und Komponenten nach dem Speichern neu laden (readOnly-Status kann sich ändern)
    // await mountedBase(uiData, pageParams, false);
    if (!uiData.saveNodeRequest) {
      await mountedBase(uiData, pageParams, false);
      columns.value = uiData.columns.filter(
        (c: any) => c.meta.invisible !== true,
      );
      setKeyComponent.value++;
    }
    if (props.backOnSave) {
      let vorgaenger = 0;
      let reloadStamm = false;
      if (updateData) {
        if (updateData.msgType === "Error") {
          reloadStamm = uiData.header.refreshNS ?? false;
        } else {
          vorgaenger = updateData.aicOld ?? 0; // bei bewegungen bekommt man nach dem Speichern einen neuen AIC}
        }
      }
      reloadStamm = uiData.header.refreshNS ?? false;
      if (props.siteData?.reloadData) {
        props.siteData.reloadData = true;
      }
      activateSaveMutable.value = false;
      setKey.value += +1;
      emit("back", updateData.data?.[0], reloadStamm, vorgaenger);
    } else {
      // Emit Save mit Nutzlast (inkl. aic_Stamm / aic_Bew_pool und Server-Response-Auszug)
      // const savePayload = {
      //   aic_Stamm: updateData.aic_Stamm,
      //   aic_Bew_pool: updateData.aic_Bew_pool,
      //   data: updateData ?? null,
      //   columns: uiData.columns,
      //   header,
      // };
      // reloadData(uiData, pageParams);
      activateSaveMutable.value = false;
      setKey.value += +1;
      emit("back", updateData.data?.[0]);
    }
  }
}
function setChange() {
  activateSaveMutable.value = true;
  setKey.value += +1;

  // $emit("changeValue");
}
</script>
<template>
  <v-card
    class="pa-0 ma-0"
    :max-width="props.maxWidth"
    :max-height="props.maxHeight ?? 600"
    :loading="uiData.showLoading"
    :style="'overflow-y:auto'"
  >
    <v-toolbar
      class="dvhBackground"
      style="color: white"
      v-if="doShowTitle || showTimeFieldLocal"
    >
      <div class="pl-2" v-if="doShowTitle">
        {{ fixTitle(uiData.header.bezeichnung) }}
      </div>

      <v-spacer></v-spacer>
      <EditDatePicker
        v-if="showTimeFieldLocal"
        v-model="stichtag"
        @changeValue="timeChanged"
        class="e-field pt-5"
        :title="
          globalsBezeichnung(
            Globals.Begriff,
            'Web_Aenderungsdatum',
            'Änderungsdatum',
          )
        "
        :placeholder="
          globalsBezeichnung(
            Globals.Begriff,
            'Web_Aenderungsdatum',
            'Änderungsdatum',
          )
        "
        :description="
          globalsBezeichnung(
            Globals.Begriff,
            'Web_Aenderungsdatum',
            'Änderungsdatum',
          )
        "
        :autofocus="false"
      ></EditDatePicker>
    </v-toolbar>

    <v-divider class="mb-2" color="green" v-if="showTimeFieldLocal"></v-divider>
    <v-card-text :style="{ marginTop: '2px' }">
      <v-container class="pa-0 ma-0" text-xs-center>
        <v-row
          v-if="uiData.initialized"
          class="pa-0 ma-0"
          dense
          :key="setKeyComponent"
        >
          <v-col
            class="edit"
            v-for="(field, index) in columns"
            :key="'field' + index"
            :cols="getColumnClass()"
          >
            <component
              :is="getEditComponent(field)"
              :queryColumn="field"
              :initValue="getEditValue(field)"
              :lastValue="getLastValue(field)"
              :initStichtag="getStichtagValue(field)"
              :initPassValue="getPassValue(field)"
              @seteditvalue="setValue"
              :description="field.title"
              :queryZeitbereich="zeitbereich"
              :readonly="readOnlyMutable"
              :stammtyp="stammtyp"
              :openFromDialog="openFromDialog"
              @changeValue="setChange"
              :aic="aic"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-divider v-if="doShowBaseButton"></v-divider>
    <v-card-actions class="text-end pa-5" v-if="doShowBaseButton">
      <v-spacer></v-spacer>
      <CommonBaseButtons
        :key="setKey"
        :createVisible="false"
        :refreshVisible="false"
        :deleteVisible="props.showDeleteButton"
        @back="emit('back')"
        :triggerNavigateBack="false"
        :backVisible="props.showBackButton"
        :saveVisible="!readOnlyMutable && activateSaveMutable"
        @delete="$emit('delete', aic)"
        @save="save"
      ></CommonBaseButtons>
    </v-card-actions>
  </v-card>
</template>
<style scoped>
.edit {
  align-content: center;
}
</style>
